
<div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="field mb-2">
            <label>Shipment Order LN: </label>
            <p class="mt-2">{{ details.shipmentOrderLN }}</p>
          </div>
        </div>
        
        <div class="col">
          <div class="field mb-2">
            <label>Tracking ID: </label>
            <ejs-textbox
                placeholder="Tracking ID"
                [value]="$safeNavigationMigration(details?.trackingId)"
                [enabled]="false"
            ></ejs-textbox>
          </div>
        </div>

        <div class="col">
          <ejs-checkbox #deliveryAck 
            label="Delivery Acknowledged" 
            [disabled]="!['Shipped'].includes(status) || deliveryAcknowBtnDisabled"
            [checked]="['Delivery Acknowledged', 'Parts Received', 'Exceptions', 'Closed'].includes(status)" 
            (change)="changeStatus($event)"
          ></ejs-checkbox>
        </div>
        <div class="col"></div>

        <div class="w-100"></div>

        <div class="col">
          <div class="field mb-2">
            <label>Shipment method: </label>
            <ejs-textbox
                placeholder="Shipment Order"
                [value]="$safeNavigationMigration(details?.shipmentMethodDescription)"
                [enabled]="false"
            ></ejs-textbox>
          </div>
        </div>

        <div class="col">
          <div class="field mb-2">
            <label>Estimated delivery:</label>
            <ejs-datepicker
                [min]=""
                [placeholder]="'Estimated Date'"
                [value]="$safeNavigationMigration(details?.estimatedDeliveryDate)"
                [readonly]="true"
            ></ejs-datepicker>
          </div>
        </div>

        <div class="col"></div>
        <div class="col"></div>

      </div>
    </div>
</div>

@if (gridConfig) {
<div [style.height.px]="gridHeight">
    <inavista-grid #shipmentOrderItemsGrid class="so-popup-grid"
        [config]="gridConfig"
        (hyperlinkClick)="onHyperlinkClick($event)"
        (exportRequested)="onExportRequested()" />
</div>
}


<app-parts-orders-popup 
    *ngIf="showPopup"
    [id]="orderId"
    [tab]="'details'"
    [data]="partOrderData"
    [showComments]='false'
    popupSource="LinkedOrders"
    (onClose)="onClosePartsPopup()"
    (onSave)="partsOrderSaved($event)"
    (onOrderPlaced)="partsOrderSaved($event)"
></app-parts-orders-popup>
